import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-42">
      <button onClick={onClick} className="w-full py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-[#D4A843] focus:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-43">
        <span className="text-lg font-semibold text-[#1B3A5C] pr-4" data-id="element-44">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0" data-id="element-45">
          <ChevronDownIcon className="w-5 h-5 text-[#D4A843]" data-id="element-46" />
        </motion.div>
      </button>

      <AnimatePresence initial={false} data-id="element-47">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-48">
            <p className="pb-5 text-gray-600 leading-relaxed" data-id="element-49">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Realmente puedo comprar con $0?',
    answer: 'Es posible llegar al cierre con $0 de enganche usando DPA. Solo necesitas un pequeño fondo para la inspección y el avalúo inicial.'
  }, {
    question: '¿Necesito ser ciudadano?',
    answer: 'No, los residentes legales y muchos titulares de visas de trabajo califican para estos programas.'
  }, {
    question: '¿Mi crédito es muy bajo?',
    answer: 'Si tienes 580-620, este plan te muestra cómo llegar al mínimo necesario rápidamente.'
  }, {
    question: '¿Tengo que devolver el dinero del gobierno?',
    answer: 'Muchos programas son "perdonables" si vives en la casa por un periodo de tiempo (usualmente 5-10 años).'
  }];
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 30
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-50px'
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="w-full bg-[#F9F6F1] py-16 md:py-24 px-4" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-3xl font-extrabold text-[#1B3A5C] text-center mb-12" data-id="element-52">
          Preguntas Frecuentes
        </motion.h2>

        <motion.div {...fadeInUp} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="bg-white rounded-2xl shadow-sm p-6 md:p-8" data-id="element-53">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-54" />)}
        </motion.div>
      </div>
    </section>;
}